export default {"src":"/_next/static/media/DifficultySwallowing.f9433139.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};